import React, { useState } from "react";
import FiltersRow from "../../swing_library/components/FiltersRow/FiltersRow";
import { useMediaQuery } from "@material-ui/core";
import Divider from "../../../components/shared/Divider/Divider";
import { IndicatorSelectList } from "../../swing_library/components/IndicatorSelectList";
import IndicatorsRow from "../../swing_library/components/IndictorsRow";

export default function CollectionTableFilters() {
  const [isIndicatorFilterOpen, setIsIndicatorFilterOpen] = useState(false);

  const isXl = useMediaQuery("(min-width: 1280px)");

  return (
    <>
      <IndicatorSelectList
        isOpen={isIndicatorFilterOpen}
        onClose={() => setIsIndicatorFilterOpen(false)}
      />

      <Divider className="my-4" color="gray200" type="horizontal" />

      <div
        className={`flex w-full items-center ${
          isXl ? "gap-3" : "flex-wrap gap-2"
        }`}
      >
        <IndicatorsRow setIsIndicatorFilterOpen={setIsIndicatorFilterOpen} />
      </div>
    </>
  );
}
